module.exports = __webpack_public_path__ + "main/assets/public/masthead/logo.6ae81911640950fb.svg";